import React, { useCallback, useState } from 'react'
import { useMutation } from '@apollo/client'
import { notification, Spin, Typography } from 'antd'

import { PageOverlay } from '../../../common/components/styled'
import { useDocumentTitle } from '../../../common/hooks/effects'

import { LOGIN_WITH_GOOGLE_ID_TOKEN, SET_USER } from '../../graphql/mutations'
import { createSession, decodeToken } from '../../services'
import { LoginPanel } from '../styled'

import { GoogleLoginButton } from './sections'

const LoginPage = () => {
  useDocumentTitle('Login')
  const [googleAccessToken, setGoogleAccessToken] = useState()
  const [setUser] = useMutation(SET_USER)

  const [loginWithGoogleIdToken, { loading }] = useMutation(
    LOGIN_WITH_GOOGLE_ID_TOKEN,
    {
      onCompleted({ loginWithGoogleIdToken: { accessToken, refreshToken } }) {
        const user = decodeToken(accessToken)
        createSession(user, accessToken, refreshToken, googleAccessToken)
        setUser({ variables: { user } })
      },

      onError({ message }) {
        notification.open({
          message: 'Login with google failed.',
          description: message,
          type: 'error',
          duration: 0,
        })
      },
    },
  )

  const onGoogleLoginSuccess = useCallback(
    ({ tokenId, accessToken }) => {
      setGoogleAccessToken(accessToken)
      loginWithGoogleIdToken({ variables: { googleIdToken: tokenId } })
    },
    [loginWithGoogleIdToken],
  )

  return (
    <>
      {loading && (
        <PageOverlay>
          <Spin tip="Loading..." />
        </PageOverlay>
      )}
      <LoginPanel>
        <Typography.Title>Testing platform - FoodStyles</Typography.Title>
        <GoogleLoginButton onSuccess={onGoogleLoginSuccess} />
      </LoginPanel>
    </>
  )
}

export default LoginPage
